export enum REACTION {
  LIKE = 1,
  DISLIKE = -1,
  NONE = 0,
}
